'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPlane = function IoPlane(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.5 24.4c0 0.5 0.1 5.4-0.4 7.9-0.1 0.4 0.2 0.4 0.4 0.6l3.9 2.6c0.2 0.1 0.3 0.6 0.3 0.6l0.1 1.4-5.4-1.2-0.9 2.5-0.9-2.5-5.4 1.2 0.1-1.4s0-0.5 0.2-0.6l4-2.6c0.2-0.2 0.5-0.2 0.4-0.6-0.5-2.5-0.4-7.4-0.4-7.9s-0.7-0.4-0.7-0.4l-4.8 1-10 3.8c0-1.8 0.2-2 0.7-2.4l14.3-10.2s0.4-5 0.4-8.9c0-1.8 0.9-6.1 2.1-6.1s2.1 4.3 2.1 6.1c0 4.2 0.4 8.9 0.4 8.9l14.3 10.2c0.5 0.3 0.7 0.6 0.7 2.4l-10-3.8-4.8-1s-0.7-0.2-0.7 0.4z' })
        )
    );
};

exports.default = IoPlane;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/plane.js
// module id = 2410
// module chunks = 0